var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _g2, _path9, _path0, _rect, _rect2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecentlyApprovedEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 125,
    viewBox: "0 0 183 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.9354 120.767C122.086 120.767 148.961 93.8919 148.961 60.6231C148.961 27.3544 121.967 0.478973 88.9354 0.478973C55.7851 0.478973 28.9097 27.3544 28.9097 60.6231C28.9097 93.8919 55.7851 120.767 88.9354 120.767Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M156.581 41.5672C159.262 41.5672 161.435 39.3939 161.435 36.713C161.435 34.0321 159.262 31.8589 156.581 31.8589C153.9 31.8589 151.727 34.0321 151.727 36.713C151.727 39.3939 153.9 41.5672 156.581 41.5672Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.685 22.6243C165.515 22.6243 167 21.1401 167 19.3093C167 17.4784 165.515 15.9942 163.685 15.9942C161.854 15.9942 160.37 17.4784 160.37 19.3093C160.37 21.1401 161.854 22.6243 163.685 22.6243Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6329 21.1978C33.4637 21.1978 34.9479 19.7136 34.9479 17.8828C34.9479 16.0519 33.4637 14.5677 31.6329 14.5677C29.8021 14.5677 28.3179 16.0519 28.3179 17.8828C28.3179 19.7136 29.8021 21.1978 31.6329 21.1978Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3874 85.1308C14.7876 85.1308 17.5439 82.3745 17.5439 78.9743C17.5439 75.5742 14.7876 72.8178 11.3874 72.8178C7.98731 72.8178 5.23096 75.5742 5.23096 78.9743C5.23096 82.3745 7.98731 85.1308 11.3874 85.1308Z",
    fill: "#EAEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2353 120.051C95.2044 120.523 92.0985 120.767 88.9355 120.767C85.1954 120.767 81.5351 120.425 77.9844 119.77V16.2297C77.9844 15.8155 78.3202 15.4797 78.7344 15.4797H97.4853C97.8995 15.4797 98.2353 15.8155 98.2353 16.2297V120.051Z",
    fill: "#D5DDEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_97_50524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.4307 51.7659H147.461V26.2647H47.4307L22.2051 38.9819L47.4307 51.7659Z",
    fill: "url(#paint0_linear_97_50524)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.486 36.9806H53.2334V32.9806H112.486V36.9806Z",
    fill: "#989FB0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.987 36.9806H118.486V32.9806H131.987V36.9806Z",
    fill: "#989FB0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_97_50524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.986 91.5178H34.9561V66.0166H134.986L160.212 78.7337L134.986 91.5178Z",
    fill: "url(#paint1_linear_97_50524)"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9839 72.7325H128.237V76.7325H68.9839V72.7325Z",
    fill: "#989FB0"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4829 72.7325H62.9835V76.7325H49.4829V72.7325Z",
    fill: "#989FB0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 78.7344,
    y: 91.9833,
    width: 18.7509,
    height: 4.50021,
    fill: "#AAB2C5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 78.7344,
    y: 52.2314,
    width: 18.7509,
    height: 4.50021,
    fill: "#AAB2C5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_97_50524",
    x: 0.205078,
    y: 15.2647,
    width: 169.256,
    height: 69.5012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_97_50524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_97_50524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_97_50524",
    x: 12.9561,
    y: 55.0166,
    width: 169.256,
    height: 69.5012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_97_50524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_97_50524",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_97_50524",
    x1: 84.7922,
    y1: 25.6749,
    x2: 84.7922,
    y2: 52.0409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_97_50524",
    x1: 97.5432,
    y1: 65.4267,
    x2: 97.5432,
    y2: 91.7927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentlyApprovedEmptyState);
export default __webpack_public_path__ + "static/media/recently-approved-empty-state.a78842539b816003b0a6810e7e17cdea.svg";
export { ForwardRef as ReactComponent };